import { z } from "zod";
import { UserSchema } from "../user";

export const ColumnActionLogSchema = z.object({
  id: z.string(),
  userId: z.string().nullable().optional(),
  workspaceId: z.string().nullable().optional(),
  sessionId: z.string(),
  evalColumnId: z.string().nullable().optional(),
  attributeTestColumnId: z.string().nullable().optional(),
  // At most one of the three definition slots is set per row, and an analytics
  // column id may only go in this one: the attribute-test slot is a foreign key
  // to `attribute_test_column`, so the database refuses one written there.
  analyticsColumnId: z.string().nullable().optional(),
  log: z.string(),
  createdAt: z.string(),
});

export const ColumnActionLogWithUserSchema = ColumnActionLogSchema.extend({
  user: UserSchema.nullable().optional(),
});
